import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { NextPageContext } from 'next';
import { GetRegionsResponse } from '@/api/types/regions.types';
import { GET_REGIONS } from '@/api/queries/regions.queries';
import { apolloClient } from '@/api/apolloClient';
import { getHostFromReq, getLangFromHost } from '@/utils/helpers';

const REGIONS_CACHE_TTL = 30 * 60 * 1000; // 30 minutes

const regionsCache = new Map<
  string,
  { data: GetRegionsResponse; cachedAt: number }
>();

export async function getRegionsCached(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
): Promise<GetRegionsResponse | null> {
  const host = context.req ? getHostFromReq(context.req) : window.location.host;
  const lang = getLangFromHost(host);
  const now = Date.now();
  const cached = regionsCache.get(lang);

  if (cached && now - cached.cachedAt < REGIONS_CACHE_TTL) {
    return cached.data;
  }

  const result = await apolloClient<GetRegionsResponse>(
    client,
    { query: GET_REGIONS },
    context
  );

  if (result?.data) {
    regionsCache.set(lang, { data: result.data, cachedAt: now });
  }

  return result?.data ?? null;
}
